module.exports = __webpack_public_path__ + "media/images/logo--primary--white-8089580196dfaba434ce05708ccf7666.png";